import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { Badge } from "../../../shared/Badge";
export var AvatarBadge = styled(Badge)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref) {
  var size = _ref.size;
  return "\n    bottom: -5px;\n    right: -5px;\n    border-radius: 100%;\n    padding: 0px;\n    border-width: 2px;\n    span:has(svg) {\n        width: ".concat(size, "px;\n        height: ").concat(size, "px;\n    }\n    ").concat(size === 18 ? "\n        bottom: -7px;\n        right: -7px;\n    " : "", "\n    ");
});
//# sourceMappingURL=AvatarBadge.js.map